"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var OneToMany = function OneToMany(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86 33.881c8.491 3.72 25.185 1.746 28.95-8.291 3.765-10.037-.134-15.502-8.625-19.2-8.49-3.7-17.327-7.128-21.073 2.909C1.366 19.335-2.63 30.182 5.86 33.88z",
    fill: "#99A1BD"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.786 12.604c-7.281-5.891-23.895-8.503-30.015.172-6.12 8.675-3.706 15.01 3.58 20.881 7.286 5.872 14.973 11.576 21.075 2.895 6.102-8.68 12.646-18.076 5.36-23.948z",
    fill: "#35B0F2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.536 28.084v-8.499l11.066 5.1v9.631L8.536 28.084z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.034 19.06V14.85l11.568 5.624v4.372L8.034 19.06zM31.17 19.06V14.85l-11.568 5.624v4.372l11.569-5.787z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.668 28.084v-8.499l-11.066 5.1v9.631l11.066-6.232zM19.1 9.59L8.033 14.85l11.48 5.497 11.657-5.496L19.099 9.59z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.006 7.073V1M19.006 1l-3.484 3.644M19.006 1l3.483 3.644",
    stroke: "#017CBF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.095 29.436l5.029 3.037M38.124 32.473l-1.276-4.977M38.123 32.473l-4.758 1.334",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.77 29.436l-5.028 3.036M1.742 32.472l1.275-4.977M1.742 32.473l4.759 1.334",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

OneToMany.defaultProps = {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var OneToOne = function OneToOne(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.632 29.31c7.801 3.495 23.14 1.64 26.599-7.791 3.46-9.432-.124-14.568-7.925-18.044C15.504 0 7.385-3.223 3.943 6.21s-7.113 19.625.689 23.101z",
    fill: "#F0BF9E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.824 7.002c-6.902-5.27-22.25-7.126-27.55 1.24-5.301 8.367-2.851 14.229 4.054 19.48 6.906 5.25 14.173 10.33 19.456 1.96 5.283-8.37 10.946-17.429 4.04-22.68z",
    fill: "#F9E89B"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.248 21.962c-.806.302-1.637 2.392-1.952 3.399.966 1.154 4.199 3.518 9.41 3.745 5.212.227 7.963-1.899 8.687-2.99-.252-1.154-.938-3.6-1.668-4.154-.913-.693-5.917-.756-7.365-.818-1.447-.063-6.105.44-7.112.818z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.42 17.01c-1.716-1.094-.708-5.096.096-6.642-2.535-.534-2.674-2.427-1.582-3.565.914-.952 2.23-.254 2.993.324.045-.496.4-1.495 1.468-1.525 1.335-.038 1.735 1.43 3.985 1.792 1.804.29 2.86 2.326 3.107 3.718.248 1.391-1.182 3.298-1.83 3.813-.518.411-1.245 1-1.487 1.086-1.573.894-5.035 2.093-6.75.999z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.517 10.368c-.805 1.546-1.813 5.548-.097 6.642 1.715 1.094 5.177-.105 6.75-.999.242-.085.969-.675 1.487-1.086.648-.515 2.078-2.422 1.83-3.813-.247-1.392-1.303-3.428-3.107-3.718-2.25-.362-2.65-1.83-3.985-1.792-1.067.03-1.423 1.03-1.468 1.525-.762-.578-2.08-1.276-2.993-.324-1.092 1.138-.953 3.031 1.583 3.565zm0 0c2.535.534 4.995-.744 6.081 0 .87.595.591 1.71.343 2.192",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.778 19.176c-.045.701.35 1.487.553 1.792-.667.432-2.23 1.3-3.145 1.315-1.144.02-2.021-1.315-1.678-1.544.343-.229.782-1.296.839-2.059.057-.762-.63-1.163.953-1.163 1.266 0 2.485-.584 2.936-.877-.134.553-.412 1.834-.458 2.536z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53 10.089A2 2 0 0 0 3.7 12.247l.234 2.82a2 2 0 0 0 2.158 1.827l3.85-.318.123-.013c.357.34.926.763 1.484.834.722.091.771.038.706 0a69.95 69.95 0 0 0-.37-1.762 2.992 2.992 0 0 0 .8-2.297l-.152-1.822a2 2 0 0 0-2.158-1.828l-4.847.4z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.701 12.247l-.498.041.498-.041zm1.828-2.158l-.04-.498.04.498zm-1.594 4.977l.498-.041-.498.041zm2.158 1.828l.041.499-.041-.499zm3.85-.318l.041.498-.041-.498zm.123-.013l.344-.363a.5.5 0 0 0-.406-.133l.062.496zm1.484.834l-.063.496.063-.497zm.706 0l-.49.097a.5.5 0 0 0 .238.334l.252-.431zm-.37-1.762l-.365-.341a.5.5 0 0 0-.122.454l.488-.113zm.8-2.297l.497-.04-.498.04zm-.152-1.822l.498-.041-.498.04zm-2.158-1.828l-.041-.499.041.499zM4.2 12.206a1.5 1.5 0 0 1 1.37-1.619l-.082-.996a2.5 2.5 0 0 0-2.285 2.697l.997-.082zm.233 2.819l-.233-2.82-.997.083.233 2.82.997-.083zm1.619 1.371a1.5 1.5 0 0 1-1.619-1.371l-.997.082a2.5 2.5 0 0 0 2.698 2.286l-.082-.997zm3.85-.319l-3.85.32.082.996 3.85-.32-.082-.996zm.102-.01a2.454 2.454 0 0 1-.102.01l.082.997a3.54 3.54 0 0 0 .143-.015l-.123-.992zm1.61.834c-.392-.05-.86-.375-1.204-.7l-.688.724c.372.354 1.04.875 1.765.968l.127-.992zm.39.927a.486.486 0 0 1-.13-.701c.102-.138.239-.17.245-.172.033-.008.052-.009.044-.008-.04.002-.188 0-.55-.046l-.126.992c.36.045.598.062.747.051a.782.782 0 0 0 .15-.024c.031-.009.183-.049.292-.196a.51.51 0 0 0 .005-.603.555.555 0 0 0-.173-.156l-.504.863zm-.604-2.08c.106.458.276 1.293.365 1.746l.981-.195a70.805 70.805 0 0 0-.372-1.777l-.975.226zm.787-2.368c.06.732-.2 1.415-.666 1.914l.73.682a3.492 3.492 0 0 0 .932-2.679l-.996.083zm-.151-1.823l.15 1.823.997-.083-.15-1.822-.997.082zm-1.619-1.371a1.5 1.5 0 0 1 1.619 1.371l.997-.082a2.5 2.5 0 0 0-2.698-2.286l.082.997zm-4.846.401l4.846-.401-.082-.997-4.847.402.083.996z",
    fill: "#33447C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.008 13.398c.084.105.249.311.342.423.038.044.067.12.125.12.03 0 .049.003.053-.033",
    stroke: "#33447C",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.418 13.094v.456M10.026 13.355c.057-.088.152-.354.26-.39",
    stroke: "#4A4A4A",
    strokeLinecap: "round"
  }));
};

OneToOne.defaultProps = {
  width: "37",
  height: "35",
  viewBox: "0 0 37 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Prospecting = function Prospecting(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.632 30.18c7.801 3.496 23.14 1.64 26.599-7.79 3.46-9.433-.124-14.568-7.925-18.044C15.504.87 7.385-2.352 3.943 7.08c-3.442 9.431-7.113 19.625.689 23.1z",
    fill: "#6FD78A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.824 7.873c-6.902-5.27-22.25-7.126-27.55 1.24-5.301 8.367-2.851 14.228 4.054 19.48 6.906 5.25 14.173 10.33 19.456 1.96 5.283-8.371 10.946-17.43 4.04-22.68z",
    fill: "#44ADA3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.283 12.49l5.34-1.166",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.239 16.692l5.023 1.647M31.166 6.795l-4.525 2.732",
    stroke: "#5C6996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.118 19.27c-.09-.86 1.054-1.71 1.461-1.962l.703 2.905c-.573.061-2.076-.085-2.164-.944z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.902 11.808c1.591-.738 4.412-3.928 4.937-5.014-.197 2.215.384 5.754 1.115 7.948.732 2.195 2.378 4.817 3.11 5.853-1.183-.207-3.919-.989-5.414-.841-1.698.167-3.603 1.09-6.009 1.58-2.95.926-7.942 1.514-8.733-3.08-.859-4.997 7.857-4.993 10.994-6.446z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.668 12.67c.646 2.184.96 4.222.955 5.743-.002.764-.085 1.368-.227 1.787-.148.435-.318.56-.416.589-.098.029-.309.017-.67-.268-.347-.274-.744-.736-1.162-1.376-.83-1.274-1.675-3.155-2.321-5.34-.646-2.184-.96-4.222-.956-5.743.003-.764.085-1.368.228-1.787.148-.435.318-.56.416-.589.098-.029.308-.017.669.268.348.274.745.736 1.163 1.376.83 1.274 1.675 3.155 2.32 5.34z",
    fill: "#fff",
    stroke: "#33447C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.522 12.275c-.687-1.882-3.317-1.357-4.546-.859 0 0-.717.856 0 2.763s1.462 2.006 1.462 2.006c1.314-.52 3.77-2.028 3.084-3.91zM10.207 25.16c.292-.812.016-2.375-.105-2.895 1.509-.468 4.629-1.222 4.67-.806.053.52-1.417 3.544-1.443 4.767-.026 1.223 1.925 3.408.65 4.422-1.274 1.015-3.486-.338-4.37-1.899-.884-1.56.234-2.575.598-3.59z",
    fill: "#fff",
    stroke: "#33447C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

Prospecting.defaultProps = {
  width: "37",
  height: "36",
  viewBox: "0 0 37 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CampaignIcons = {
  [_services.CampaignType.Prospecting]: (0, _material.styled)(Prospecting)({}),
  [_services.CampaignType.One2One]: (0, _material.styled)(OneToOne)({}),
  [_services.CampaignType.One2Many]: (0, _material.styled)(OneToMany)({})
};

var CampaignIcon = function CampaignIcon(_ref) {
  var variant = _ref.variant,
      sx = _ref.sx;
  var Icon = CampaignIcons[variant];
  return Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
    sx: sx
  }) : null;
};

var _default = CampaignIcon;
exports.default = _default;